let API_BASE = "/api";

export class CommunityConstants {
  public static COMMUNITY_SINGLE = API_BASE + "/community/{communityId}";
  public static COMMUNITY_GROUPS = API_BASE + "/community-groups";
  public static COMMUNITY_GROUP_SINGLE =
    API_BASE + "/community-group/{communityGroupId}";
}
